const state = {
  namespaced: true,
  state: {},
  actions: {},
  mutations: {},
  getters: {}
};

export default state
